import React, { useContext, useState } from 'react';
import { Button, Modal, Input, Form, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { EventContext } from 'modules/dashboard/pagesv2/event';
import { deleteNote, createNote, updateNote } from 'api/events';

export const NotesModal = ({
  isVisible = false,
  isReadNote = false,
  isAddNote = false,
  handleOk,
  handleCancel,
  notes = [],
  clubId,
  refetch,
  groups,
}) => {
  const { TextArea } = Input;

  const { eventId } = useContext(EventContext);

  const [isUpdateVisible, setIsUpdateVisible] = useState(false);
  const [editNote, setEditNote] = useState('');
  const [editNoteId, setEditNoteId] = useState(0);

  const findClubName = () => {
    const clubName = groups?.find(group => group.club.id === clubId);
    return clubName?.club?.name;
  };

  const handleUpdateOk = () => {
    setIsUpdateVisible(false);
  };

  const handleUpdateCancel = () => {
    setIsUpdateVisible(false);
  };

  const showUpdateModal = (noteId, note) => {
    setIsUpdateVisible(true);
    setEditNote(note);
    setEditNoteId(noteId);
  };

  const handleOnSubmitAddNote = async ({ addNote }) => {
    try {
      await createNote(eventId, clubId, addNote);
      handleOk();
      message.success('!Nota agregada!');
      refetch();
    } catch (error) {
      message.error('!Algo ha salido mal!');
    }
  };

  const handleOnSubmitUpdateNote = async ({ editNote }) => {
    try {
      await updateNote(editNoteId, editNote);
      setIsUpdateVisible(false);
      message.success('Nota actualizada!');
      refetch();
    } catch (error) {
      message.error('!Algo ha salido mal!');
    }
  };

  const handleOnSubmitRemoveNote = async noteId => {
    try {
      await deleteNote(noteId);
      handleUpdateOk();
      message.success('!Nota eliminada!');
      refetch();
    } catch (error) {
      message.error('!Algo ha salido mal!');
    }
  };

  return (
    <>
      <Modal
        visible={isUpdateVisible}
        title={`Editar nota de ${findClubName()}`}
        onOk={() => handleUpdateOk()}
        onCancel={() => handleUpdateCancel()}
        footer={[
          <Button key="back" onClick={() => handleUpdateCancel()}>
            Cancelar
          </Button>,
          <Button form={'editForm'} htmlType="submit" key="submit" type="primary">
            Editar
          </Button>,
        ]}
      >
        <Form id={'editForm'} onFinish={values => handleOnSubmitUpdateNote(values)}>
          <Form.Item
            initialValue={editNote}
            label="Nota"
            name="editNote"
            rules={[
              {
                required: true,
                message: 'Ingresa una nota valida!',
              },
            ]}
          >
            <TextArea />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={isVisible}
        title={isReadNote ? `Notas de ${findClubName()}` : `Agrega nota a ${findClubName()}`}
        onOk={() => handleOk()}
        onCancel={() => handleCancel()}
        footer={
          isReadNote
            ? [
                <Button key="submit" type="primary" onClick={() => handleOk()}>
                  Cerrar
                </Button>,
              ]
            : [
                <Button key="back" onClick={() => handleCancel()}>
                  Cancelar
                </Button>,
                <Button form={'addForm'} htmlType="submit" key="submit" type="primary">
                  Agregar
                </Button>,
              ]
        }
      >
        {isReadNote &&
          notes.map(note => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                }}
                key={note.id}
              >
                {note.body}
                <div className="text-right" style={{ width: '100px' }}>
                  <Tooltip title="Editar nota">
                    <Button
                      type="primary"
                      className="mr-2"
                      icon={<EditOutlined />}
                      size="small"
                      onClick={() => showUpdateModal(note.id, note.body)}
                    />
                  </Tooltip>
                  <Tooltip title="Borrar nota">
                    <Button
                      type="primary"
                      danger
                      className="mr-2"
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={() => handleOnSubmitRemoveNote(note.id)}
                    />
                  </Tooltip>
                </div>
              </div>
            );
          })}
        {isAddNote && (
          <Form id={'addForm'} onFinish={values => handleOnSubmitAddNote(values)}>
            <Form.Item
              label="Nota"
              name="addNote"
              rules={[
                {
                  required: true,
                  message: 'Ingresa una nota valida!',
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
};
